export function courseSelectorFnMaker(id) {
    return session => {
        const course = session.Course.withId(String(id));
            if (course === null) {
                return null;
            }
            return Object.assign({}, course.ref, {
                teachers: course.teachers.toRefArray().map(teacher => Object.assign({}, teacher)),
            });
    }
}